export const formatCurrency = (amount?: number | string | null): string => {
  return amount
    ? `$${amount.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    : "$0"
}
